export default theme => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "16px",
    marginBottom: "8px",
  },
  title: {
    margin: 0,
  },
  instructions: {
    marginBottom: "16px",
    display: "block",
  },
  accordion: {
    marginBottom: "8px",
  },
  audioAccordion: {
    marginBottom: "8px",
  },
  accordionSummary: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: "12px",
  },
  labelContainer: {
    flex: 1,
    minWidth: 0,
  },
  labelInput: {
    maxWidth: "300px",
  },
  description: {
    marginTop: "4px",
    display: "block",
  },
  controlsContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexShrink: 0,
  },
  controlGroup: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  addAudioButton: {
    fontSize: "0.7rem",
    padding: "2px 8px",
    minWidth: "auto",
  },
  accordionDetails: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px",
  },
  divider: {
    marginTop: "8px",
    marginBottom: "16px",
  },
  urlText: {
    wordBreak: "break-all",
    fontSize: "1rem",
  },
  steerableContainer: {
    padding: "16px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
  },
  steerableTitle: {
    marginBottom: "16px",
  },
  steerableFields: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  steerableExpSection: {
    marginTop: "8px",
  },
  steerableExpUrl: {
    marginTop: "12px",
  },
  urlParametersHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  urlParametersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "16px",
  },
  parameterRow: {
    display: "flex",
    gap: "8px",
    alignItems: "flex-start",
    padding: "8px",
    borderRadius: "4px",
    backgroundColor: "#fafafa",
  },
  parameterFields: {
    flex: 1,
    display: "flex",
    gap: "8px",
  },
  parameterField: {
    flex: 1,
  },
  removeButton: {
    marginTop: "8px",
  },
  noParametersText: {
    marginTop: "8px",
  },
  parameterItem: {
    display: "flex",
    gap: "8px",
    alignItems: "flex-start",
    padding: "12px",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    backgroundColor: "#fafafa",
  },
  dividerSpacing: {
    marginTop: "16px",
  },
  overlayFieldsContainer: {
    padding: "16px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
  },
  overlayFields: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
  },
});
